// ======================================================================
// File: PurchaseRequestListPage.jsx
// Module: PPE → Procurement → Purchase Request
//
// FIXED VERSION
// - Proper drawer mounting
// - Cleaner state handling
// - UX refinements
// ======================================================================

import React, { useState } from "react";

import usePurchaseRequestList from "../hooks/usePurchaseRequestList";

import PRKpiBar from "./PRKpiBar";
import PRFilterBar from "./PRFilterBar";
import prColumns from "./prColumns";

import "../pr-ui.css";

import PurchaseRequestFormDrawer from "../form/PurchaseRequestFormDrawer";
import PurchaseRequestViewDrawer from "../view/PurchaseRequestViewDrawer";

import Pagination from "../../../../../../components/common/Pagination";
import Loader from "../../../../../../components/common/Loader";

export default function PurchaseRequestListPage() {

  const [filters, setFilters] = useState({});
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [drawerMode, setDrawerMode] = useState(null);

  const {
    loading,
    records,
    summary,
    pagination,
    setPagination,
    reload,
  } = usePurchaseRequestList(filters);

  // ============================================================== 
  // HANDLERS
  // ============================================================== 
  const handleCreate = () => {
    setSelectedRecord(null);
    setDrawerMode("create");
  };

  const handleView = (row) => {
    setSelectedRecord(row);
    setDrawerMode("view");

  };
  const handleEdit = (row) => {
  setSelectedRecord(row);
  setDrawerMode("edit");
};

  const handleCloseDrawer = () => {
    setDrawerMode(null);
    setSelectedRecord(null);
  };

  // ============================================================== 
  // RENDER
  // ============================================================== 
  return (
    <>

      <div className="pr-page">

        {/* HEADER BANNER */}
        <div className="pr-header-banner">
          <div>
            <h2>Purchase Request Management</h2>
            <p className="pr-subtitle">
              Internal material procurement authorization
            </p>
          </div>

          <button
              className="btn-accent"
            onClick={handleCreate}
          >
            + Create Purchase Request
          </button>
        </div>

        {/* KPI + FILTER SECTION */}
        <div className="pr-content-section">

          <PRKpiBar summary={summary} />

          <PRFilterBar
            filters={filters}
            onChange={setFilters}
            onSearch={reload}
          />

        </div>

        {/* TABLE SECTION */}
        <div className="pr-table-wrapper">

          {loading ? (
            <Loader />
          ) : (
            <table className="pr-table">
              <thead>
                <tr>
                  {prColumns.map((col) => (
                    <th key={col.key}>{col.label}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {records.length === 0 && (
                  <tr>
                    <td colSpan={prColumns.length}>
                      No purchase requests found
                    </td>
                  </tr>
                )}

                {records.map((row) => (
                  <tr key={row.id}>
                    {prColumns.map((col) => (
                      <td key={col.key}>
                        {col.render
                          ? col.render(
                              row,
                              handleView,
                              handleEdit
                            )
                          : row[col.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* PAGINATION */}
<Pagination
  page={pagination.page}
  pageSize={pagination.pageSize}
  total={pagination.total}
  onPageChange={(page) =>
    setPagination((p) => ({
      ...p,
      page,
    }))
  }
/>


      </div>

      {/* ------------------------------------------------------------
          DRAWERS RENDERED OUTSIDE MAIN CONTAINER (IMPORTANT)
          ------------------------------------------------------------ */}

      {(drawerMode === "create" ||
         drawerMode === "edit") && (
        <PurchaseRequestFormDrawer
            open={true}
            recordId={selectedRecord?.id}
            onClose={handleCloseDrawer}
            onSaved={() => {
              handleCloseDrawer();
              reload();
            }}
          />
      )}

      {drawerMode === "view" && selectedRecord && (
        <PurchaseRequestViewDrawer
          open={true}
          recordId={selectedRecord.id}
          onClose={handleCloseDrawer}
          onUpdated={reload}
        />
      )}

    </>
  );
}
